import useMediaURL from 'hooks/useMediaURL';
import React, { useState, useEffect } from 'react';

const VideoLogo = ({ file_id, hash, location }) => {
  const { url } = useMediaURL(location);
  if (!url) return null;

  return (
    <img
      style={{
        maxWidth: 180,
        maxHeight: 80,
        height: '100%',
        objectFit: 'contain',
      }}
      src={url}
    />
  );
};

export default VideoLogo;
